import { Box, Text, Flex } from '@chakra-ui/react'
import React from 'react'
import { ActionItemFieldsFragment } from '~graphql/generated/graphql'
import { SharedAssignee, SharedTag } from './shared'
import { getClientFullName } from '~utils/helpers'

export default function NewChatContent({
    actionItem,
}: {
    actionItem: ActionItemFieldsFragment
}) {
    if (!actionItem.chat) {
        return <Box display="none" />
    }

    const { client, last_message, last_message_time } = actionItem.chat

    return (
        <Box w="full">
            <Box mt={1}>
                <Flex justify="space-between">
                    <Text fontSize="md" fontWeight="semibold">
                        {getClientFullName(client)} sent you a message
                    </Text>

                    {!!actionItem.assignee && (
                        <SharedAssignee assignee={actionItem.assignee} />
                    )}
                </Flex>
                <Text fontSize="sm" color="gray.600" noOfLines={1}>
                    {last_message}
                </Text>
            </Box>
        </Box>
    )
}
